let Quiz = class extends HTMLElement
{
   constructor()
   {
      super();
      this.flkty = null;
   }

   connectedCallback()
   {
      const dataEl = this.querySelector('.quiz-data-script');
      if (!dataEl)
      {
         console.error('Quiz data script not found inside <quiz> element.');
         return;
      }

      try
      {
         this.data = JSON.parse(dataEl.textContent);
      } catch (e)
      {
         console.error('Error parsing quiz data', e);
         return;
      }

      this.stage = this.querySelector('.quiz-stage');
      this.progText = this.querySelector('.quiz-progress-text');
      this.progFill = this.querySelector('.quiz-progress-fill');

      this.questions = Array.isArray(this.data.questions) ? this.data.questions : [];
      const outcomesArr = Array.isArray(this.data.outcomes) ? this.data.outcomes : [];
      this.outcomes = {};
      outcomesArr.forEach(o =>
      {
         if (o && o.letter)
         {
            this.outcomes[String(o.letter).toUpperCase()] = o;
         }
      });

      this.idx = 0;
      this.counts = {};
      this.questions.forEach(q =>
      {
         (q.answers || []).forEach(a =>
         {
            const L = String(a.letter || '').toUpperCase();
            if (!(L in this.counts)) this.counts[L] = 0;
         });
      });

      this.init();
   }

   init()
   {
      if (this.questions.length === 0)
      {
         if (this.stage) this.stage.innerHTML = '<p>Nessuna domanda disponibile.</p>';
         return;
      }

      this.renderProgress();

      if (this.data.use_flickity && window.Flickity && typeof window.Flickity === 'function')
      {
         this.initFlickity();
      } else
      {
         this.renderSlide(0);
      }
   }

   renderProgress()
   {
      const total = this.questions.length;
      const current = Math.min(this.idx, total);
      if (this.progText)
      {
         this.progText.textContent = total ? `${current}/${total}` : '';
      }
      if (this.progFill)
      {
         this.progFill.style.width = (total ? (current / total) * 100 : 0).toFixed(2) + '%';
      }
   }

   clearStage()
   {
      if (this.stage) this.stage.innerHTML = '';
   }

   renderSlide(qIndex)
   {
      this.clearStage();
      const q = this.questions[qIndex];
      if (!q) return;

      const slide = document.createElement('div');
      slide.className = 'quiz-slide active';

      if (q.image)
      {
         const fig = document.createElement('figure');
         fig.className = 'quiz-img';
         fig.innerHTML = '<img loading="lazy" alt="">';
         fig.querySelector('img').src = q.image;
         slide.appendChild(fig);
      }
      const h = document.createElement('h3');
      h.className = 'quiz-q';
      h.textContent = q.question;
      slide.appendChild(h);

      const answers = document.createElement('div');
      answers.className = 'quiz-answers';
      (q.answers || []).forEach(a =>
      {
         const L = String(a.letter || '').toUpperCase();
         const btn = document.createElement('button');
         btn.type = 'button';
         btn.className = 'quiz-answer';
         btn.setAttribute('data-letter', L);
         btn.setAttribute('aria-label', `${L} ${a.text}`);
         btn.innerHTML = `<span class="badge">${L}</span><span>${a.text}</span>`;
         btn.addEventListener('click', () =>
         {
            this.counts[L] = (this.counts[L] || 0) + 1;
            this.idx++;
            this.renderProgress();
            if (this.idx < this.questions.length)
            {
               this.renderSlide(this.idx);
            } else
            {
               this.renderResult();
            }
         }, { once: true });
         answers.appendChild(btn);
      });
      slide.appendChild(answers);

      this.stage.appendChild(slide);
   }

   pickWinner(counts, strategy)
   {
      let max = -Infinity;
      let letters = [];
      for (const L in counts)
      {
         if (counts[L] > max)
         {
            max = counts[L];
         }
      }
      for (const L in counts)
      {
         if (counts[L] === max)
         {
            letters.push(L);
         }
      }
      if (letters.length === 1) return letters[0];
      if ((strategy || 'first') === 'random')
      {
         return letters[Math.floor(Math.random() * letters.length)];
      }
      letters.sort();
      return letters[0];
   }

   renderResult()
   {
      this.clearStage();
      const winner = this.pickWinner(this.counts, this.data.tie_break_strategy || 'first');
      const res = this.outcomes[winner] || { title: `Risultato ${winner}`, description: '', image: null };

      const wrap = document.createElement('div');
      wrap.className = 'quiz-result';
      const h = document.createElement('h3');
      h.classList.add('h5', 'quiz-title');
      h.textContent = res.title || `Risultato ${winner}`;
      const p = document.createElement('div');
      p.className = 'desc';
      p.innerHTML = (res.description || '').replace(/\n/g, '<br>');
      wrap.appendChild(h);
      wrap.appendChild(p);
      if (res.image)
      {
         const fig = document.createElement('figure');
         fig.className = 'res-img';
         fig.innerHTML = '<img loading="lazy" alt="">';
         fig.querySelector('img').src = res.image;
         wrap.appendChild(fig);
      }
      this.stage.appendChild(wrap);
   }

   initFlickity()
   {
      this.stage.innerHTML = '';
      this.questions.forEach((q) =>
      {
         const cell = document.createElement('div');
         cell.className = 'quiz-slide';
         if (q.image)
         {
            const fig = document.createElement('figure');
            fig.className = 'quiz-img';
            fig.innerHTML = '<img loading="lazy" alt="">';
            fig.querySelector('img').src = q.image;
            cell.appendChild(fig);
         }
         const h = document.createElement('h3');
         h.className = 'quiz-q';
         h.textContent = q.question;
         cell.appendChild(h);
         const answers = document.createElement('div');
         answers.className = 'quiz-answers';
         (q.answers || []).forEach(a =>
         {
            const L = String(a.letter || '').toUpperCase();
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'quiz-answer';
            btn.setAttribute('data-letter', L);
            btn.setAttribute('aria-label', `${L} ${a.text}`);
            btn.innerHTML = `<span class="badge">${L}</span><span>${a.text}</span>`;
            btn.addEventListener('click', () =>
            {
               this.counts[L] = (this.counts[L] || 0) + 1;
               this.idx++;
               this.renderProgress();
               if (this.idx < this.questions.length)
               {
                  try
                  {
                     this.flkty.next(true, false);
                  } catch (e) { }
               } else
               {
                  const parent = this.stage;
                  this.flkty.destroy();
                  parent.innerHTML = '';
                  this.renderResult();
               }
            }, { once: true });
            answers.appendChild(btn);
         });
         cell.appendChild(answers);
         this.stage.appendChild(cell);
      });

      this.flkty = new Flickity(this.stage, {
         cellAlign: 'left',
         contain: true,
         prevNextButtons: false,
         pageDots: true,
         draggable: false,
         wrapAround: false,
         adaptiveHeight: true,
      });
   }
}

if (!window.customElements.get("quiz-item"))
{
   window.customElements.define("quiz-item", Quiz);
}